import { HealthCheck } from "../utils/api/api_types";
import coreApi from "../utils/api/coreApi";
import { Textarea, Group, Stack, Text, Button } from "@mantine/core";
import { useForm } from "@mantine/form";
import useApiSubmit from "../utils/api/useApiSubmit";
import { IconDeviceFloppy } from "@tabler/icons-react";

const HealthCheckDescription = ({
  healthCheck,
  onDescriptionUpdated,
}: {
  healthCheck: HealthCheck;
  onDescriptionUpdated: () => void;
}) => {
  const form = useForm({
    initialValues: {
      description: healthCheck.description || "",
    },
  });

  const { loading, handleSubmit, nonFieldErrors, resetErrors } = useApiSubmit({
    apiFunc: (data) => coreApi.healthChecksUpdate(healthCheck.id, data),
    form,
    onSuccess: (res) => {
      const newDescription = res.description;
      form.setFieldValue("description", newDescription);
      onDescriptionUpdated();
    },
  });

  const updateDisabled =
    JSON.stringify(healthCheck.description || "") ===
    JSON.stringify(form.values.description || "");

  return (
    <>
      <form
        onSubmit={(e) => {
          resetErrors();
          e.preventDefault(); // stop page reload
          form.onSubmit(handleSubmit)(e);
        }}
      >
        <Group align="flex-start" mt="sm">
          <Stack w="100%" gap={5}>
            <Group justify="space-between">
              <Text>
                <b>Description</b>
                {!updateDisabled && (
                  <Text span c="red" fw={500}>
                    {" "}
                    (not saved)
                  </Text>
                )}
              </Text>
              <Button
                color="brand.5"
                disabled={updateDisabled}
                loading={loading}
                type="submit"
                variant="filled"
                leftSection={<IconDeviceFloppy />}
                size="compact-sm"
              >
                Save
              </Button>
            </Group>
            <Group align="flex-start">
              <Textarea
                w="100%"
                minRows={2}
                maxRows={10}
                autosize
                placeholder="Add description/notes..."
                {...form.getInputProps("description")}
              />
            </Group>
            {nonFieldErrors && nonFieldErrors.length > 0 ? (
              <Text size="sm" c="red" my="md">
                {nonFieldErrors}
              </Text>
            ) : (
              <></>
            )}
          </Stack>
        </Group>
      </form>
    </>
  );
};

export default HealthCheckDescription;
